export default __webpack_public_path__ + "static/media/21.38b26d81.png";